<script lang="ts">    
    import { type Match } from './src/types'    
    
    export let match:Match;


</script>

    <td>{match.date}</td>
    <td>{match.opponent}</td>
    {#if match.double} 
        <td>&nbsp;</td>
    {:else}
        <td>{match.otherRanking}</td>
    {/if}
    <td>{match.score.me}</td>
    <td>{match.score.other}</td>
    <td>{match.score.me > match.score.other ? '👍' : '👎'}</td>
    {#if !match.double} 
        <td>{match.delta > 0 ?  "↗️" : "↘️"} {Math.abs(match.delta)}</td>
    {:else}
        <td>&nbsp;</td>
    {/if}


